module.exports = __webpack_public_path__ + "img/12-2.b77a3524.jpg";